import {Box, Skeleton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppButton, AppButtonVariant} from '@/app/shared-components/AppButton';
import {COLORS} from '@/styles/colors';

import {IGroupMember} from '../../models/interfaces';
import {GroupMemberItem} from '../GroupMemberItem/GroupMemberItem';

const MemberSkeletonItem = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      mb={1.5}>
      <Skeleton
        variant="circular"
        width={40}
        height={40}
      />
      <Box
        ml={2}
        flex={1}>
        <Skeleton
          variant="text"
          width="40%"
        />
        <Skeleton
          variant="text"
          width="60%"
        />
      </Box>
    </Box>
  );
};

interface GroupMembersProps {
  members: IGroupMember[];
  onInvite?: () => void;
  isLoading?: boolean;
}

export const GroupMembers: React.FC<GroupMembersProps> = ({
  members,
  onInvite,
  isLoading = false,
}) => {
  const {t} = useTranslation();
  return (
    <Box className="groups-dashboard-members">
      <Box className="groups-dashboard-members-header">
        {isLoading ? (
          <Skeleton
            variant="text"
            width={120}
            height={28}
          />
        ) : (
          <Typography className="groups-dashboard-members-header-title">
            {t('groups.dashboard.members_count', {count: members.length})}
          </Typography>
        )}

        {isLoading ? (
          <Skeleton
            variant="text"
            width={60}
            height={28}
          />
        ) : (
          <AppButton
            id="group-dashboard-invite-button"
            label={t('groups.dashboard.invite_button')}
            onClick={onInvite}
            variant={AppButtonVariant.onText}
            labelColor={COLORS.ON_SURFACE_1}
            removeStyles
          />
        )}
      </Box>

      <Box className="groups-dashboard-members-list">
        {isLoading
          ? Array.from({length: 3}).map((_, i) => (
              <MemberSkeletonItem key={i} />
            ))
          : members.map(member => (
              <GroupMemberItem
                key={member.id}
                name={member.name}
                description={member.description}
                isYou={member.isYou}
                isOwner={member.isOwner}
              />
            ))}
      </Box>
    </Box>
  );
};
